import { useContext } from 'react';
import { usePreventScroll } from 'react-aria';
import {
  ComboBoxStateContext as RACComboBoxStateContext,
  ListBox as RACListBox,
  ListLayout as RACListLayout,
  type ListLayoutOptions as RACListLayoutOptions,
  Virtualizer as RACVirtualizer,
} from 'react-aria-components';
import type { CollectionItem } from '../types.js';
import type { TagFieldProps } from './tag-field.js';

const VIRTUAL_LAYOUT_OPTIONS: RACListLayoutOptions = {
  estimatedRowHeight: 36,
  estimatedHeadingHeight: 32,
  padding: 0,
  gap: 0,
};

/** @internal */
export function TagFieldListBox<T extends CollectionItem>({
  children,
  items,
  onScroll,
  isVirtualized,
}: Pick<TagFieldProps<T>, 'children' | 'items' | 'onScroll' | 'isVirtualized'>) {
  const comboBoxState = useContext(RACComboBoxStateContext);

  usePreventScroll({ isDisabled: !comboBoxState?.isOpen });

  const listBox = (
    <RACListBox className="cim-combo-box-listbox" onScroll={onScroll} items={items}>
      {children}
    </RACListBox>
  );

  return isVirtualized ? (
    <RACVirtualizer layout={RACListLayout} layoutOptions={VIRTUAL_LAYOUT_OPTIONS}>
      {listBox}
    </RACVirtualizer>
  ) : (
    listBox
  );
}
